import { template as template_f7fa5a2edfba402c83d4dec8140fc630 } from "@ember/template-compiler";
import { buildAgeGroupFacetOptions } from 'client-portal/utils/clinicianSearch/age-group-facet-options';
import { facetOptionDisabled } from 'client-portal/utils/clinicianSearch/facet-catalog';
import { fn } from '@ember/helper';
import { parseTrimmedString } from 'client-portal/utils/clinicianSearch/comma-query-param';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import RequestClinicianSearchFiltersFilterRadioLine from '../filters/filter-radio-line';
import RequestClinicianSearchFiltersPanel from '../filters/panel';
import styles from './age-group.module.scss';
import t from 'ember-intl/helpers/t';
const RADIO_NAME = 'clinician-search-age-group-filter';
export default class RequestClinicianSearchFacetFiltersAgeGroup extends Component {
    @service
    intl;
    @service
    clinicianSearch;
    radioName = RADIO_NAME;
    @tracked
    options = [];
    @tracked
    loadFailed = false;
    @tracked
    isLoadingOptions = true;
    get selectedAgeGroup() {
        return parseTrimmedString(this.clinicianSearch.query.ageGroup);
    }
    get panelLoading() {
        return this.isLoadingOptions || this.clinicianSearch.sendAll.isLoading;
    }
    get loadingAriaLabel() {
        if (this.clinicianSearch.sendAll.isLoading) {
            return this.intl.t('booking.clinicianSearch.filterDetail.filterOptionsLoading');
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.ageGroupOptionsLoading');
    }
    refreshOptions = ()=>{
        this.loadFailed = false;
        this.isLoadingOptions = true;
        try {
            let routeParams = {
                ...this.clinicianSearch.query.toRouteParams(),
                ageGroup: null
            };
            let meta = this.clinicianSearch.sendAll.buildFacetsMeta(routeParams);
            this.options = buildAgeGroupFacetOptions(meta?.facets?.ageGroups ?? []);
        } catch  {
            this.loadFailed = true;
            this.options = [];
        } finally{
            this.isLoadingOptions = false;
        }
    };
    isOptionSelected = (option)=>this.selectedAgeGroup.toLowerCase() === String(option.key ?? '').toLowerCase();
    optionDisabled = (option)=>facetOptionDisabled(option.docCount, this.isOptionSelected(option));
    optionRowTitle = (option)=>{
        if (!this.optionDisabled(option)) {
            return '';
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.disabledFilterOption');
    };
    selectAgeGroup = (option, event)=>{
        if (!event.target.checked || !option.key) {
            return;
        }
        this.clinicianSearch.query.applyFacetFilter('ageGroup', option.key);
        this.clinicianSearch.mobile.backFromDetail();
    };
    static{
        template_f7fa5a2edfba402c83d4dec8140fc630(`
    <RequestClinicianSearchFiltersPanel
      @hideApply={{true}}
      @class={{styles.component}}
      class="clinician-search-filter-age-group-options"
      @facetKey="ageGroup"
      @isLoading={{this.panelLoading}}
      @loadingAriaLabel={{this.loadingAriaLabel}}
      @onLoad={{this.refreshOptions}}
      data-test-clinician-search-filter-age-group-options
    >
      <p class="filter-section-title" id="clinician-search-age-group-filter-title">{{t
          "booking.clinicianSearch.filterDetail.ageGroupFilterPanelTitle"
        }}</p>
      {{#if this.loadFailed}}
        <p class="error" data-test-clinician-search-filter-age-group-options-error>
          {{t "booking.clinicianSearch.filterDetail.ageGroupLoadError"}}
        </p>
      {{/if}}
      <div class="body" role="group" aria-labelledby="clinician-search-age-group-filter-title">
        <ul class="filter-checkbox-list" role="list">
          {{#each this.options as |option|}}
            <RequestClinicianSearchFiltersFilterRadioLine
              @kind="age-group"
              @optionId={{option.slug}}
              @docCount={{option.docCount}}
              @name={{this.radioName}}
              @value={{option.key}}
              @checked={{this.isOptionSelected option}}
              @disabled={{this.optionDisabled option}}
              @title={{this.optionRowTitle option}}
              @onChange={{fn this.selectAgeGroup option}}
            >
              {{t option.labelKey}}
            </RequestClinicianSearchFiltersFilterRadioLine>
          {{/each}}
        </ul>
      </div>
    </RequestClinicianSearchFiltersPanel>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
